import AboutCardStyleWrapper from "./AboutCard.style";

const AboutCard = ({ title, icon, text }) => {
  return (
    <AboutCardStyleWrapper className="about_us_text_card">
      <h3>
        <img src={icon} alt="ALPHA OCTOPUS About us" height={100} width={80}/>
        {title}
      </h3>
      <p>{text}</p>
    </AboutCardStyleWrapper>
  );
};

export default AboutCard;
